import { isMobile, isTablet } from 'react-device-detect';
import styled from 'styled-components';

import keyImage from '../../assets/keys/key.png';
import keySpaceImage from '../../assets/keys/key-space.png';

export const Wrapper = styled.div`
	box-shadow: 0px 3.3368983268737793px 45.048126220703125px 0px #4f6dbbbf;
	border-radius: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 15px)`
			: `calc(${p.scale} * 30px)`};
	padding: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 20px)`
			: `calc(${p.scale} * 40px)`};
	/* width: 30%; */
	display: flex;
	width: ${(p) => (p.scale && !isMobile && !isTablet ? '60%' : '40%')};
	margin: auto;
	position: relative;
	.switch {
		img {
			box-shadow: 0px 0px 45.048126220703125px 0px #726fe740;
			border-radius: ${(p) =>
				p.scale && !isMobile && !isTablet
					? `calc(${p.scale} * 12px)`
					: `calc(${p.scale} * 24px)`};
			width: ${(p) =>
				p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 76px)` : `40%`};
			max-width: 76px;
			display: flex;
		}
	}
	.text {
		flex: 0 0 69%;
	}
	@media only screen and (min-width: 667px) {
		width: ${(p) => (p.scale && !isMobile && !isTablet ? '60%' : '90%')};
	}
`;
export const BonusWrapper = styled.div`
	box-shadow: 0px 4px 84px 0px #97bf4373;
	border-radius: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 18px)`
			: `calc(${p.scale} * 33px)`};
	padding: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 20px)`
			: `calc(${p.scale} * 40px)`};
	display: flex;
	width: ${(p) => (p.scale && !isMobile && !isTablet ? '50%' : '40%')};
	margin: auto;
	position: relative;
	.text {
		width: 100%;
		flex: 0 0 70%;
	}
	@media only screen and (min-width: 667px) {
		width: ${(p) => (p.scale && !isMobile && !isTablet ? '52%' : '85%')};
	}
`;

export const Icon = styled.div`
	position: relative;
	flex: 0 0 45%;
	img {
		width: 100%;
		position: absolute;
		right: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * 20px)`
				: `calc(${p.scale} * 51px)`};
		bottom: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * -20px)`
				: `calc(${p.scale} * -40px)`};
		width: ${(p) => (p.scale && !isMobile && !isTablet ? '100%' : '100%')};
		/* transform:${(p) =>
			p.scale &&
			!isMobile &&
			!isTablet &&
			`translate(calc(${p.scale} * 100%), 5%)`}; */
	}
`;

export const BonusIcon = styled.div`
	position: relative;
	flex: ${!isMobile && !isTablet ? '0 0 80%' : '0 0 70%'};
	img {
		width: 100%;
		position: absolute;
		right: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * 50px)`
				: `calc(${p.scale} * 123px)`};
		bottom: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * -40px)`
				: `calc(${p.scale} * -93px)`};
		width: ${(p) => (p.scale && !isMobile && !isTablet ? '100%' : '90%')};
		@media only screen and (min-width: 667px) {
			width: ${(p) => (p.scale && !isMobile && !isTablet ? '95%' : '100%')};
		}
	}
`;
export const Title = styled.h1`
	font-family: 'poppins-bold';
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 35px)` : '5.2vw'};
	background: linear-gradient(180deg, #9b61e4 -20.83%, #6c25b4 79.17%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	max-width: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 190px)` : `100px`};
	@media only screen and (min-width: 667px) {
		flex-direction: row;
		max-width: ${(p) =>
			p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 190px)` : `140px`};
	}
`;

export const BonusTitle = styled.h1`
	font-family: 'poppins-bold';
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 18px)` : '3vw'};
	color: #cfdbb5;
	text-transform: uppercase;
`;

export const Desc = styled.p`
	text-transform: uppercase;
	font-family: 'poppins-bold';
	color: #bab5db;
	margin: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 10px) 0`
			: `calc(${p.scale} * 10px) 0 5px`};
	line-height: 1;
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 15px)` : '1.8vw'};
	span {
		background: linear-gradient(98.71deg, #7eba21 42.48%, #447e15 89.98%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`;

export const BonusDesc = styled.p`
	font-family: 'poppins-bold';
	text-transform: uppercase;
	background: linear-gradient(180deg, #92cf25 -0.49%, #225a0f 110.88%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	line-height: 1;
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 30px)` : '4.3vw'};
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	max-width: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 160px)` : `90px`};
	@media only screen and (min-width: 667px) {
		flex-direction: row;
		max-width: ${(p) =>
			p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 140px)` : `120px`};
	}
`;

export const Description = styled.p`
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 20px)` : '2.2vw'};
	width: ${!isMobile && !isTablet ? '70%' : '70%'};
	text-align: center;
	margin: 0 auto;
	padding: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 40px) calc(${p.scale} * 20px)`
			: `calc(${p.scale} * 60px) calc(${p.scale} * 20px)`};
	color: #dee0ef;
	font-family: 'Poppins Regular';
	@media only screen and (min-width: 667px) {
		width: ${!isMobile && !isTablet ? '70%' : '100%'};
	}
`;

export const QuestIcon = styled.div`
	margin: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 20px) auto`
			: `20px auto`};
	img {
		width: ${(p) =>
			p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 280px)` : `50%`};
	}
`;

export const VolatilityIcon = styled.div`
	margin: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 20px) auto`
			: `20px auto`};
	text-align: center;
	img {
		width: ${(p) =>
			p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 448px)` : `50%`};
	}
`;
export const KeyBox = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex: 1 0 40%;
	&&.space {
		/* flex: 1 0 100%; */
	}
	.arrows {
		display: flex;
		gap: 3.5px;
	}
`;

export const Key = styled.div`
	background: url(${keyImage});
	background-size: 100%;
	background-repeat: no-repeat;
	font-family: 'poppins-bold', sans-serif;
	color: #201b24;
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	width: ${(p) =>
		p.scale && !(isMobile && isTablet) ? `calc(${p.scale} * 77px)` : `9vw`};
	height: ${(p) =>
		p.scale && !(isMobile && isTablet) ? `calc(${p.scale} * 77px)` : `10vw`};
	font-size: ${(p) =>
		p.scale && !(isMobile && isTablet) ? `calc(${p.scale} * 23px)` : `3.2vw`};

	& > span {
		transform: translate(
			${(p) =>
				p.scale && !(isMobile && isTablet)
					? `calc(${p.scale} * -7px), calc(${p.scale} * -4px)`
					: '-0.6vw, -0.6vh'}
		);
	}

	&&.space {
		background: url(${keySpaceImage});
		background-repeat: no-repeat;
		background-size: 100%;
		width: ${(p) =>
			p.scale && !(isMobile && isTablet)
				? `calc(${p.scale} * 221px)`
				: `221px`};
		height: ${(p) =>
			p.scale && !(isMobile && isTablet) ? `calc(${p.scale} * 74px)` : `74px`};
		text-transform: uppercase;
	}

	&&.arrow {
		width: ${(p) =>
			p.scale && !(isMobile && isTablet) ? `calc(${p.scale} * 57px)` : `57px`};
		height: ${(p) =>
			p.scale && !(isMobile && isTablet) ? `calc(${p.scale} * 57px)` : `57px`};
		display: flex;
		align-items: center;

		svg {
			width: ${(p) =>
				p.scale && !(isMobile && isTablet)
					? `calc(${p.scale} * 12px)`
					: `12px`};
		}
	}
`;

export const KeyDesc = styled.div`
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 24px)` : `3vw`};
	color: #dee0ef;
	padding-left: 10px;
	flex: 1 0 70%;
`;

export const QuestItemWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 10px;
	width: 90%;
	margin: 20px auto;
`;

export const QuestItemBox = styled.div`
	background: rgba(114, 44, 143, 0.1);
	box-shadow: 0px 4px 74px 0px rgba(114, 141, 237, 0.25);
	padding: 10px;
	padding: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 10px)`
			: `calc(${p.scale} * 20px)`};
	display: flex;
	align-items: center;
	justify-content: center;
	flex: ${!isMobile && !isTablet ? '1 0 44%' : '1 0 50%'};
	border-radius: 10px;
	gap: 1.8vh;
	max-width: 70%;
`;
export const QuestItemContent = styled.div`
	text-align: left;
	font-family: 'Poppins Semibold';
	height: 100%;
	flex: 1 0 70%;
`;
export const QuestItemTitle = styled.div`
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 22px)` : `2.6vw`};
	color: ${(p) => p.color};
	/* line-height: 1.6; */
`;
export const QuestItemDescription = styled.div`
	color: rgba(222, 224, 239, 1);
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 16px)` : `2.2vw`};
	/* line-height: 1.6; */
	margin: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `0 0 calc(${p.scale} * 10px) 0`
			: `calc(${p.scale} * 20px) 0`};
	img {
		width: 100%;
		max-width: ${(p) =>
			p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 14px)` : `2.2vw`};
		vertical-align: middle;
		margin-right: 5px;
	}
	span {
		color: rgba(62, 84, 250, 1);
	}
`;
export const QuestItemIcon = styled.div`
	img {
		width: 100%;
		max-width: 80px;
		vertical-align: middle;
	}
`;
export const QuestItemProgress = styled.div`
	width: 100%;
	background: rgba(29, 12, 44, 1);
	border-radius: 12px;
	position: relative;
	height: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 16px)`
			: `calc(${p.scale} * 34px)`};
	.progress_text {
		font-size: ${(p) =>
			p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 12px)` : `1.2vw`};
		text-align: center;
		position: absolute;
		right: 50%;
		transform: translateX(50%);
		top: 0;
	}
	.progress_inner {
		position: absolute;
		width: ${(p) => p.width + '%'};
		height: 100%;
		left: 0;
		top: 0;
		border-radius: 12px;
		background: linear-gradient(90deg, #e5a7dd 1.39%, #efb6a9 100%);
	}
	@media only screen and (min-width: 1024px) {
		height: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * 16px)`
				: `calc(${p.scale} * 34px)`};
	}
`;
